// EBS - Blulab edition


/*! erbolario-quantity-limit.js — Limite quantità per riga (drawer + /cart)
 * Semplice: blocca il "+" oltre il limite e mostra un messaggio contestuale.
 * Non tocca API/cart: agisce solo sull'UI per spiegare all'utente il perché.
 */
(() => {
  'use strict';

  /*** CONFIG ***/
  const MAX_PER_ITEM = 6; // <— imposta qui il limite globale per variante
  // const MESSAGE_TEXT = (max) => `Puoi acquistare al massimo ${max} unità per questo articolo.`;
  const MESSAGE_TEXT = (max) => `Hai raggiunto la quantità massima disponibile per questo prodotto.`;

  // Selettori coerenti con il tuo tema Blockshop custom
  const ROW_SELECTOR          = '.cart--item';
  const PLUS_SELECTOR         = '.quantity-selector--plus';
  const MINUS_SELECTOR        = '.quantity-selector--minus';
  const INPUT_SELECTOR        = '.quantity-selector--input';
  const TITLE_WRAP_SELECTOR   = '.cart--item--title';   // dove il tema mette già .cart--error
  const BUILTIN_ERROR_SELECTOR= '.cart--error';         // stile nativo del tema (riusiamo)
  const OUR_ERROR_CLASS       = 'erbolario-qty-error';  // marcatore per il nostro messaggio

  /*** UTILS ***/
  const closest = (el, sel) => el?.closest?.(sel) || null;
  const qs = (sel, root=document) => root.querySelector(sel);

  const getQty = (row) => {
    const input = qs(INPUT_SELECTOR, row);
    if (input) {
      const n = parseInt(input.value, 10);
      if (!Number.isNaN(n)) return n;
    }
    // fallback a data-quantity se presente
    const dq = parseInt(row.getAttribute('data-quantity') || '', 10);
    return Number.isNaN(dq) ? 0 : dq;
  };

  // Trova o crea un contenitore messaggio coerente con lo stile del tema
  const getOrCreateErrorEl = (row) => {
    // 1) Se esiste già un .cart--error dentro la riga, riusalo
    let el = qs(BUILTIN_ERROR_SELECTOR, row);
    if (el) return el;

    // 2) Prova a inserirlo accanto al titolo (migliore resa)
    const titleWrap = qs(TITLE_WRAP_SELECTOR, row) || row;

    el = document.createElement('div');
    el.className = `cart--error ${OUR_ERROR_CLASS}`;
    el.setAttribute('data-item', 'small-text');
    el.setAttribute('data-text-color', 'alert');
    el.setAttribute('role', 'alert');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-hidden', 'true');
    titleWrap.appendChild(el);
    return el;
  };

  const showLimitMessage = (row, max) => {
    const el = getOrCreateErrorEl(row);
    el.textContent = MESSAGE_TEXT(max);
    el.setAttribute('aria-hidden', 'false');
    el.style.display = ''; // visibile (nel caso il tema la nasconda via inline)
    row.classList.add('has-qty-limit-error');
  };

  const hideLimitMessage = (row) => {
    // Nasconde SOLO il nostro messaggio o qualsiasi .cart--error presente
    const el = qs(`.${OUR_ERROR_CLASS}`, row) || qs(BUILTIN_ERROR_SELECTOR, row);
    if (el) {
      el.setAttribute('aria-hidden', 'true');
      // Non rimuovo il nodo per evitare layout shift: lo tengo nascosto
      // Se preferisci rimuoverlo: el.remove();
    }
    row.classList.remove('has-qty-limit-error');
  };

  /*** HANDLERS ***/
  // 1) Clic su "+" → se già al limite, blocca e mostra messaggio
  document.addEventListener('click', (ev) => {
    const plusBtn = ev.target.closest?.(PLUS_SELECTOR);
    if (!plusBtn) return;

    const row = closest(plusBtn, ROW_SELECTOR);
    if (!row) return;

    const qty = getQty(row);
    if (qty >= MAX_PER_ITEM) {
      // Blocca qualsiasi handler del tema che invierebbe una change al carrello
      ev.preventDefault();
      ev.stopImmediatePropagation();

      showLimitMessage(row, MAX_PER_ITEM);

      // (opzionale) piccolo feedback vibrazione su device touch
      if (navigator.vibrate) navigator.vibrate(8);
    } else {
      // Stiamo ancora sotto limite → assicuriamoci di non mostrare l'errore
      hideLimitMessage(row);
    }
  }, true); // uso capture per fermare gli handler del tema in anticipo

  // 2) Clic su "-" → nascondi eventuale messaggio se si torna sotto limite
  document.addEventListener('click', (ev) => {
    const minusBtn = ev.target.closest?.(MINUS_SELECTOR);
    if (!minusBtn) return;
    const row = closest(minusBtn, ROW_SELECTOR);
    if (!row) return;

    // Ritarda di un tick per leggere il valore aggiornato dall'handler del tema
    setTimeout(() => {
      const qty = getQty(row);
      if (qty < MAX_PER_ITEM) hideLimitMessage(row);
    }, 0);
  });

  // 3) Edit manuale dell'input → se > max, clamp visivo e mostra messaggio; se <= max, nascondi
  document.addEventListener('change', (ev) => {
    const input = ev.target.closest?.(INPUT_SELECTOR);
    if (!input) return;

    const row = closest(input, ROW_SELECTOR);
    const val = parseInt(input.value, 10);
    if (Number.isNaN(val)) return;

    if (val > MAX_PER_ITEM) {
      input.value = String(MAX_PER_ITEM); // clamp lato UI per chiarezza
      showLimitMessage(row, MAX_PER_ITEM);
    } else {
      hideLimitMessage(row);
    }
  });

  // 4) Quando il drawer/cart viene rigenerato (es. da altri script), pulisci eventuali residui
  //    Se usi lo script "erbolario-cart.js" che emette questi event, li intercettiamo:
  ['erbolario:cart:drawer-refreshed', 'erbolario:cart:count-updated'].forEach(evt => {
    document.addEventListener(evt, () => {
      document.querySelectorAll(`.${OUR_ERROR_CLASS}`).forEach(el => {
        el.setAttribute('aria-hidden', 'true');
        el.parentElement?.classList?.remove('has-qty-limit-error');
      });
    });
  });

  // 5) Opzionale: esponi un'API per cambiare il limite a runtime
  window.ErbolarioQtyLimit = {
    setMax(n) {
      const x = parseInt(n, 10);
      if (!Number.isNaN(x) && x > 0) {
        // eslint-disable-next-line no-console
        console.log('[erbolario-quantity-limit] max changed to', x);
        // NB: in uno script minimale potresti voler salvare MAX_PER_ITEM in window.*;
        // qui manteniamo semplice: chiudi sull'impostazione iniziale.
      }
    }
  };
})();
